class DateDecoder {
    decode(data) {
        return new Date(data.integer);
    }
}
Date.prototype.encode = function (context) {
    return this.getTime();
};
// We export an instance to prevent creating a new instance every time we need to decode a number
export default new DateDecoder();
//# sourceMappingURL=DateDecoder.js.map